import CustomDialog from "../../common/CustomDialog";
import FormField from "../../common/FormField";
import CustomButton from "../../common/CustomButton";
import { useEffect, useState } from "react";
import useApiServices from "../../../utils/useApiServices";
import { GET_ALL_ACTIVE_VEHICAL_MASTER, GET_ALL_ACTIVE_VEHICAL_MASTER_FOR_SID } from "../../../utils/constant";


export default function CreateSIDForm({
    open,
    onHandleClose,
    formData,
    handleChange,
    handleSubmit,
    isSubmitting,
    formErrors,
}) {
    const { apiCallFnforGet } = useApiServices();
    const title = "Create SID";
    const [vehicleOptions, setVehicleOptions] = useState([]);
    const [loadingVehicles, setLoadingVehicles] = useState(false);

    const handleKeyDown = (e) => {
        try {
            if (e?.key === "Enter" && e?.target?.type !== "textarea") {
                e?.preventDefault();
                handleSubmit(e);
            }
        } catch (error) {
            console.log(`Error: ${error}`);
        }
    };

    // Fetch vehicle names from API
    useEffect(() => {
        const fetchVehicles = async () => {
            setLoadingVehicles(true);
            try {
                const response = await apiCallFnforGet(GET_ALL_ACTIVE_VEHICAL_MASTER_FOR_SID);
                setVehicleOptions(response?.data || []);
            } catch (error) {
                console.error("Error fetching vehicle names:", error);
            } finally {
                setLoadingVehicles(false);
            }
        };

        fetchVehicles();
    }, []);

    return (
        <CustomDialog
            open={open}
            onClose={onHandleClose}
            title={title}
            actions={
                <>
                    <CustomButton
                        variant="outlined"
                        label="Cancel"
                        onClick={onHandleClose}
                    />
                    <CustomButton
                        variant="contained"
                        label={isSubmitting ? "Saving..." : "Create SID"}
                        type="submit"
                        disabled={isSubmitting}
                        loading={isSubmitting}
                        onClick={handleSubmit}
                    />
                </>
            }
        >
            <div className="row">
                {/* DOMAIN NAME  */}
                <div className="col-12 col-md-6">
                    <FormField
                        label="Domain Name"
                        name="domainName"
                        type="text"
                        value={formData["domainName"] || ""}
                        onChange={handleChange}
                        onKeyDown={handleKeyDown}
                        placeholder="Enter Service Provider"
                        required
                        error={formErrors?.["domainName"]}
                    />
                </div>

                {/* ENC Key */}
                <div className="col-12 col-md-6">
                    <FormField
                        label="Salt"
                        name="encKey"
                        type="text"
                        value={formData["encKey"] || ""}
                        onChange={handleChange}
                        onKeyDown={handleKeyDown}
                        placeholder="Enter Encryption Key"
                        required
                        error={formErrors?.["encKey"]}
                    />
                </div>

                {/* Email */}
                <div className="col-12 col-md-6">
                    <FormField
                        label="Email Id"
                        name="emailId"
                        type="email"
                        value={formData["emailId"] || ""}
                        onChange={handleChange}
                        onKeyDown={handleKeyDown}
                        placeholder="Enter Email Id"
                        required
                        error={formErrors?.["emailId"]}
                    />
                </div>

                {/* Mobile */}
                <div className="col-12 col-md-6">
                    <FormField
                        label="Mobile No"
                        name="mobileNo"
                        type="number"
                        value={formData["mobileNo"] || ""}
                        onChange={handleChange}
                        onKeyDown={handleKeyDown}
                        placeholder="Enter Mobile No"
                        required
                        error={formErrors?.["mobileNo"]}
                    />
                </div>

                {/* Vehicle Name */}
                {/* <div className="col-12 col-md-6">
                    <FormField
                        label="Vehicle Name"
                        name="vehicleName"
                        type="text"
                        value={formData["vehicleName"] || ""}
                        onChange={handleChange}
                        onKeyDown={handleKeyDown}
                        placeholder="Enter Vehicle Name"
                        required
                        error={formErrors?.["vehicleName"]}
                    />
                </div> */}


                {/* Vehicle Name - Dropdown */}
                <div className="col-12 col-md-6">
                    <label className="form-label mb-1">
                        Vehicle Name <span className="required">*</span>
                    </label>
                    <select
                        name="vehicleName"
                        className="form-control"
                        value={formData["vehicleName"] || ""}
                        onChange={handleChange}
                        disabled={loadingVehicles}
                    >
                        <option value="">Select Vehicle</option>
                        {vehicleOptions?.map((vehicle, index) => (
                            <option
                                key={index || vehicle}
                                value={vehicle}
                            >
                                {vehicle}
                            </option>
                        ))}
                    </select>
                    {formErrors?.["vehicleName"] && (
                        <small className="text-danger">{formErrors["vehicleName"]}</small>
                    )}
                </div>

                {/* Service Provider */}
                <div className="col-12 col-md-6">
                    <FormField
                        label="Service Provider"
                        name="serviceProvider"
                        type="text"
                        value={"Payu"}
                        readOnly
                        required
                        placeholder="Service Provider"
                    />
                </div>
            </div>
        </CustomDialog>
    );
}